import { callNative } from '@ifit/native-webview-interface';
import { AnalyticsNames } from '../models/analytics-names';
import { IParams } from '../models/dictionary';

let callNativeFunc: typeof callNative = callNative;

export function setAnalyticsEvent(newCallNative: typeof callNative): void {
  callNativeFunc = newCallNative || callNative;
}

export function sendEvent(
  eventName: AnalyticsNames | string,
  params: IParams,
): void {
  callNativeFunc({
    methodName: 'postAnalyticsEvent',
    eventName: eventName,
    ...params,
  });
}
